<ng-container
  *ngIf="addressEditorTranslations$ | async as addressEditorTranslations"
>
  <ng-container
    *ngIf="validationTranslations$ | async as validationTranslations"
  >
    <ng-container
      *ngIf="
        generalInformationTranslation$ | async as generalInformationTranslation
      "
    >
      <form [formGroup]="form">
        <div class="form-row">
          <div class="col-md-12">
            <div class="form-group">
              <label for="companyName" class="h4">{{
                addressEditorTranslations['LabelCompanyName']
              }}</label>
              <input
                id="companyName"
                formControlName="companyName"
                class="form-control"
              />
              <span
                *ngIf="
                  companyName?.invalid &&
                  (companyName?.dirty || companyName?.touched)
                "
                class="text-danger"
              >
                {{ validationTranslations['InputRequired'] }}
              </span>
            </div>
          </div>
        </div>
        <div class="form-row">
          <div class="col-md-12">
            <div class="form-group">
              <label for="companyAddon" class="h4">{{
                addressEditorTranslations['LabelCompanyAddon']
              }}</label>
              <input
                id="companyAddon"
                formControlName="companyAddon"
                class="form-control"
              />
              <span
                *ngIf="
                  companyAddon?.invalid &&
                  (companyAddon?.dirty || companyAddon?.touched)
                "
                class="text-danger"
              >
                {{ validationTranslations['InputRequired'] }}
              </span>
            </div>
          </div>
        </div>
        <div class="form-row">
          <div class="col-md-12">
            <div class="form-group">
              <label for="addressLine1" class="h4">{{
                addressEditorTranslations['LabelAddressLine1']
              }}</label>
              <input
                id="addressLine1"
                formControlName="addressLine1"
                class="form-control"
              />
              <span
                *ngIf="
                  addressLine1?.invalid &&
                  (addressLine1?.dirty || addressLine1?.touched)
                "
                class="text-danger"
              >
                {{ validationTranslations['InputRequired'] }}
              </span>
            </div>
          </div>
        </div>
        <div class="form-row">
          <div class="col-md-12">
            <div class="form-group">
              <label for="addressLine2">{{
                addressEditorTranslations['LabelAddressLine2']
              }}</label>
              <input
                id="addressLine2"
                formControlName="addressLine2"
                class="form-control"
              />
            </div>
          </div>
        </div>
        <div class="form-row">
          <div class="col-md-12">
            <div class="form-group">
              <label for="addressLine3">{{
                addressEditorTranslations['LabelAddressLine3']
              }}</label>
              <input
                id="addressLine3"
                formControlName="addressLine3"
                class="form-control"
              />
            </div>
          </div>
        </div>
        <div class="form-row">
          <div class="col-md-12">
            <div class="form-group">
              <label for="companyAddon" class="h4">{{
                addressEditorTranslations['LabelZipCode']
              }}</label>
              <input
                id="zipCode"
                type="number"
                formControlName="zipCode"
                class="form-control"
              />
              <span
                *ngIf="zipCode?.invalid && (zipCode?.dirty || zipCode?.touched)"
                class="text-danger"
              >
                {{ validationTranslations['InputRequired'] }}
              </span>
            </div>
          </div>
        </div>
        <div class="form-row">
          <div class="col-md-12">
            <div class="form-group">
              <label for="place" class="h4">{{
                addressEditorTranslations['LabelPlace']
              }}</label>
              <input id="place" formControlName="place" class="form-control" />
              <span
                *ngIf="place?.invalid && (place?.dirty || place?.touched)"
                class="text-danger"
              >
                {{ validationTranslations['InputRequired'] }}
              </span>
            </div>
          </div>
        </div>

        <div class="form-group">
          <label for="country" class="h4">{{
            addressEditorTranslations['LabelCountry']
          }}</label>
          <select id="country" formControlName="country" class="form-control">
            <option *ngFor="let c of countries" [value]="c.Id">
              {{ c.Text }}
            </option>
          </select>
          <span
            *ngIf="country?.invalid && (country?.dirty || country?.touched)"
            class="text-danger"
          >
            {{ validationTranslations['InputRequired'] }}
          </span>
        </div>

        <div class="form-group">
          <p class="text-muted small">
            {{ generalInformationTranslation['Paragraph2'] }}
          </p>
        </div>
      </form>
      <div id="ch-ggs-web-suite-form-navigation">
        <div class="row mt-6">
          <div class="col-6">
            <button
              (click)="cancel()"
              class="btn btn-iconed btn-iconed-default-white btn-iconed-left float-left w-auto"
            >
              {{ addressEditorTranslations['ButtonCancel'] }}
              <i class="btn-icon ifc-custom ifc-arrow-left"></i>
            </button>
            <button
              (click)="save()"
              class="btn btn-iconed btn-iconed-primary float-right w-auto"
            >
              {{ addressEditorTranslations['ButtonApply'] }}
              <i class="btn-icon ifc-custom ifc-arrow-right"></i>
            </button>
          </div>
        </div>
      </div>
    </ng-container>
  </ng-container>
</ng-container>
